module.exports = __webpack_public_path__ + "static/media/Vaishakhee.8da2456d.jpg";